import { z } from "zod";

/**
 * TrocarSenhaSchema
 */

export const TrocarSenhaSchema = z.object({
  login: z.string().default(''),
  senhaAtual: z.string().default(''),
  novaSenha: z.string().default(''),
  confirmarNovaSenha: z.string().default(''),
}).superRefine((data, ctx) => {
  if (!data.login || data.login.trim().length === 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Este campo deve ser preenchido!",
      path: ["login"],
    });
  }

  if (!data.senhaAtual || data.senhaAtual.trim().length === 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Este campo deve ser preenchido!",
      path: ["senhaAtual"],
    });
  }

  if (!data.novaSenha || data.novaSenha.trim().length === 0) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "Este campo deve ser preenchido!",
      path: ["novaSenha"],
    });
  }

  if (data.novaSenha.trim().length < 6) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "A nova senha deve ter pelo menos 6 caracteres!",
      path: ["novaSenha"],
    });
  }

  if (data.novaSenha.length > 50) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["novaSenha"],
      message: "A nova senha deve ter no máximo 50 caracteres",
    });
  }

  if (!/[0-9]/.test(data.novaSenha)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["novaSenha"],
      message: "A nova senha deve conter pelo menos um número",
    });
  }

  if (!/[A-Z]/.test(data.novaSenha)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["novaSenha"],
      message: "A nova senha deve conter pelo menos uma letra maiúscula",
    });
  }

  if (!/[a-z]/.test(data.novaSenha)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["novaSenha"],
      message: "A nova senha deve conter pelo menos uma letra minúscula",
    });
  }

  if (!/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(data.novaSenha)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["novaSenha"],
      message: "A nova senha deve conter pelo menos um caractere especial",
    });
  }

  if (data.confirmarNovaSenha !== data.novaSenha) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: "A confirmação de senha não coincide com a nova senha!",
      path: ["confirmarNovaSenha"],
    });
  }
});

/**
 * TrocarSenhaForm
 */

export type TrocarSenhaForm = z.infer<typeof TrocarSenhaSchema>;